import NRAnthropicIcon from '../../NRIcons/AIProviderIcons/NRAnthropicIcon';
import NRDeepseekIcon from '../../NRIcons/AIProviderIcons/NRDeepseekIcon';
import NRGoogleIcon from '../../NRIcons/AIProviderIcons/NRGoogleIcon';
import NRMetaIcon from '../../NRIcons/AIProviderIcons/NRMetaIcon';
import NROpenaiIcon from '../../NRIcons/AIProviderIcons/NROpenaiIcon';
import NRVertexaiIcon from '../../NRIcons/AIProviderIcons/NRVertexaiIcon';
import NRXaiIcon from '../../NRIcons/AIProviderIcons/NRXaiIcon';
import NRAnthropicDarkIcon from '../../NRIcons/AIProviderIcons/NRAnthropicDarkIcon';
import NRDeepseekDarkIcon from '../../NRIcons/AIProviderIcons/NRDeepseekDarkIcon';
import NROpenaiDarkIcon from '../../NRIcons/AIProviderIcons/NROpenaiDarkIcon';
import NRXaiDarkIcon from '../../NRIcons/AIProviderIcons/NRXaiDarkIcon';
import NRAITag from '../../NRIcons/NRAITag';

// Keys intentionally match provider names from public-api MOCK_AI_PROVIDERS.
export const AI_PROVIDER_ICON_MAP = {
  Anthropic: NRAnthropicIcon,
  Google: NRGoogleIcon,
  OpenAI: NROpenaiIcon,
  Groq: null,
  'Vertex AI': NRVertexaiIcon,
  Mistral: null,
  watsonx: null,
  Alibaba: null,
  AWS: null,
  Azure: null,
  Baseten: null,
  'Black Forest Labs': null,
  ByteDance: null,
  Cerebras: null,
  Cohere: null,
  Deepgram: null,
  DeepInfra: null,
  DeepSeek: NRDeepseekIcon,
  Fal: null,
  Fireworks: null,
  xAI: NRXaiIcon,
  'Hugging Face': null,
  KlingAI: null,
  Luma: null,
  'Moonshot AI': null,
  Perplexity: null,
  Prodia: null,
  Replicate: null,
  'Rev AI': null,
  'Together AI': null,
  Vercel: null,
  Meta: NRMetaIcon,
  NVIDIA: null,
  Ollama: null
};

// Use dark variant when available; otherwise fall back to light icon.
export const AI_PROVIDER_DARK_ICON_MAP = {
  Anthropic: NRAnthropicDarkIcon,
  Google: NRGoogleIcon,
  OpenAI: NROpenaiDarkIcon,
  Groq: null,
  'Vertex AI': NRVertexaiIcon,
  Mistral: null,
  watsonx: null,
  Alibaba: null,
  AWS: null,
  Azure: null,
  Baseten: null,
  'Black Forest Labs': null,
  ByteDance: null,
  Cerebras: null,
  Cohere: null,
  Deepgram: null,
  DeepInfra: null,
  DeepSeek: NRDeepseekDarkIcon,
  Fal: null,
  Fireworks: null,
  xAI: NRXaiDarkIcon,
  'Hugging Face': null,
  KlingAI: null,
  Luma: null,
  'Moonshot AI': null,
  Perplexity: null,
  Prodia: null,
  Replicate: null,
  'Rev AI': null,
  'Together AI': null,
  Vercel: null,
  Meta: NRMetaIcon,
  NVIDIA: null,
  Ollama: null
};

export const getAIProviderIcon = ({ provider, useDarkIcon = false, theme }) => {
  const providerMap = useDarkIcon ? AI_PROVIDER_DARK_ICON_MAP : AI_PROVIDER_ICON_MAP;
  const ProviderIcon = providerMap[provider];
  if (ProviderIcon) {
    return ProviderIcon;
  }

  return ({ width, height }) => (
    <NRAITag width={width} height={height} color={useDarkIcon ? theme?.palette?.tooltip?.color : theme?.palette?.riseAiPurple} />
  );
};
